import React from 'react';

/**
 * テキスト内の ITreview (URL) パターンを検出し、ITreview をリンクに変換する。
 * URLの括弧部分は非表示にし、直前にスペースがなければ追加する。
 */
export const renderTextWithLinks = (text: string, linkColor: string): React.ReactNode[] => {
  const linkStyle = { color: linkColor };
  const regex = /(ITreview)\s*\((https?:\/\/[^\s)]+)\)/g;
  const result: React.ReactNode[] = [];
  let lastIndex = 0;
  let match = regex.exec(text);

  while (match !== null) {
    const before = text.slice(lastIndex, match.index);
    if (before) {
      result.push(before);
    }
    // 直前がスペースでない場合はスペースを追加
    const charBefore = match.index > 0 ? text[match.index - 1] : '';
    if (charBefore && charBefore !== ' ') {
      result.push(' ');
    }
    result.push(
      <a key={match.index} href={match[2]} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {match[1]}
      </a>
    );
    lastIndex = match.index + match[0].length;
    match = regex.exec(text);
  }
  if (lastIndex < text.length) {
    result.push(text.slice(lastIndex));
  }
  return result;
};
